import {useEffect} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {useSession} from "@/components/shop/SessionProvider";
import {useShopSite} from "@/components/shop/ShopSiteProvider";
import {pathRequiresAuth, paths} from "@/lib/paths";

export function AuthGate({children}: {children: React.ReactNode}) {
  const {user, ready, sessionChecked} = useSession();
  const {status, ready: siteReady} = useShopSite();
  const navigate = useNavigate();
  const {pathname} = useLocation();
  const isAdmin = pathname.startsWith("/vadmin");
  const isPublicPath = pathname === paths.login || pathname === paths.presentation;

  useEffect(() => {
    if(!ready || !sessionChecked || !siteReady || isAdmin) return;
    if(user?.authenticated) return;
    if(!pathRequiresAuth(pathname, status)) return;
    navigate(paths.login, {replace: true, state: {from: pathname}});
  }, [ready, sessionChecked, siteReady, user, pathname, navigate, isAdmin, status]);

  if(isAdmin || user?.authenticated) return <>{children}</>;
  if(!ready || !sessionChecked || !siteReady) {
    // Avoid flashing catalog chrome/content before we know public vs private.
    if(isPublicPath) return <>{children}</>;
    return null;
  }
  if(pathRequiresAuth(pathname, status)) return null;
  return <>{children}</>;
}
